var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SlideSidebarContainer',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('UserIntroduceBox',{attrs:{"user":_vm.user}})]},proxy:true}])},[_c('UserMenuNavbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }